/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76042ResDataItemChildListItem {
  
  /** 任务id */
  bizNo?: string;
  
  /** 任务内容 */
  taskTitle?: string;
  
  /** 任务内容 */
  taskContent?: string;
  
  /** 任务状态 */
  taskStatus?: string;
  
  /** 是否正常 */
  isNormal?: string;
  
  /** 截止时间 */
  endTime?: string;
  
};
    
  
    
export interface IAPI76042ResDataItem {
  
  /** 任务id */
  bizNo?: string;
  
  /** task */
  taskTitle?: string;
  
  /** 任务id */
  endTime?: string;
  
  /** 子任务信息列表 ,TaskInstanceChildInfoResp */
  childList?: IAPI76042ResDataItemChildListItem[];
  
};
    
  



export type API76042Req = {};



export type API76042Res = IAPI76042ResDataItem[];


// 接口函数 76042 任务实例列表按组

export interface IUseGetAPI76042Return {
  /** 任务实例列表按组: 接口请求状态 */
  isAPI76042Loading: boolean;
  /** 任务实例列表按组: 接口请求返回数据 */
  dataAPI76042: API76042Res;
  /**  任务实例列表按组: 接口数据请求方法 */
  fetchAPI76042Data: ( config?: YWRequestConfig) => Promise<API76042Res>;
  /** 任务实例列表按组: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76042 = ():IUseGetAPI76042Return => {
  let isMount = true;
  const [isAPI76042Loading, setIsAPI76042Loading] = useState(false);
  const [dataAPI76042, setDataAPI76042] = useState<API76042Res>({} as API76042Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/list/group`;

  const fetchAPI76042Data = async ( config?: YWRequestConfig): Promise<API76042Res> => {
  
    if ( isMount ) {
      setIsAPI76042Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76042Res>(`${basePath}/yoaichat-web/task/instance/list/group`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76042(res || {} as API76042Res);
        setIsAPI76042Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76042Loading(false);
      }
      return false as unknown as API76042Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76042Loading,
    dataAPI76042,
    fetchAPI76042Data,
    requestUrl,
  }
}

